import { directLogin } from "../../constants/actionTypes";

const INITIAL_STATE = {
  verifyDirectTenant: {},
  invalidDirectTenant: {},
};

const directLabLogin = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case directLogin.DIRECT_LOGIN_TENANT_VERIFIED:
      return {
        ...state,
        verifyDirectTenant: action?.payload,
      };
    case directLogin.DIRECT_LOGIN_TENANT_FAIL:
      return {
        ...state,
        invalidDirectTenant: action?.payload,
      };

    default:
      return state;
  }
};

export default directLabLogin;
